import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteAmenityMutation, useGetAmenityByIdQuery } from "../../../services/bClientApi"
import AmenityEntry from "../../../Components/Amenity/AmenityEntry/AmenityEntry"

export default function DeleteAmenityPage() {

    const [
        deleteAmenity,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteAmenityMutation()

    const { amenityId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetAmenityByIdQuery(amenityId, { skip: !amenityId || deleteClicked })
    const amenityData = data || {}

    const amenityDeleteFn = async () => {
        if (amenityId) {
            const deleteValue = await deleteAmenity(amenityId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/amenities/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {amenityId && amenityData && !isLoading && (
                        <div className="amenity-info">
                            <div className="mb-4">
                                <h4>Amenity to Delete</h4>
                                <AmenityEntry
                                    amenityData={amenityData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this amenity? This action cannot be undone.
                                </div>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/amenity/${amenityId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="warning"
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Amenity
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This amenity will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button
                                            variant="danger"
                                            disabled={deleteLoading}
                                            onClick={() => {
                                                amenityDeleteFn()
                                            }}
                                        >
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Amenity'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
